import React, { FC, useState } from "react";
import { Button } from "../../../../index";
import { Select, Spin } from "antd";
import { useViewerStore } from "../../../../../store/store";
import { productionEstimateService } from "../../../../../services/ProductionEstimateService";
import {useCurrentUser} from "../../../../../contexts/UserContext";





const ProductionEstimateForm = () => {
    // Retrieve `sceneViewer` from your store. Adjust the type as needed.
    const sceneViewer = useViewerStore((state) => state.sceneViewer);
    const {user} = useCurrentUser()

    // State for selecting partner
    const [selectedItem, setSelectedItem] = useState<"Sunnova" | "IGS">("Sunnova");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [estimate, setEstimate] = useState<number | string | null>(null);
    const [isSelecting, setIsSelecting] = useState<boolean>(true);

    // Error-related state
    const [isError, setIsError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const onRetrieveEstimate = async () => {
        setIsLoading(true);
        setEstimate(null);
        setIsSelecting(false);

        try {
            let value: number | string;
            if (selectedItem === "Sunnova") {
                value = await productionEstimateService.getSunnovaEstimate();
            } else {
                value = await productionEstimateService.getIGSEstimate();
            }
            setIsError(false);
            setEstimate(value);
        } catch (error: unknown) {
            console.error("Error retrieving estimate:", error);

            if (error instanceof Error) {
                setErrorMessage(error.message);
            } else {
                setErrorMessage(String(error));
            }

            setIsError(true);
            setEstimate("Failed to retrieve estimate");
        } finally {
            setIsLoading(false);
            setIsSelecting(false);
        }
    };

    const cancelFinalize = () => {
        sceneViewer.viewerAlert({ show: false });
    };

    const onGoBack = () => {
        setIsSelecting(true);
        setEstimate(null);
    };

    const items = (user && user.application_role_name == "Admin") ?
        [
            {key: "Sunnova", value: "Sunnova", text: "Sunnova"},
            {key: "IGS", value: "IGS", text: "IGS"},
        ]
        :
        [
            {key: "Sunnova", value: "Sunnova", text: "Sunnova"},
        ];

    const onChange = (value: "Sunnova" | "IGS") => {
        setSelectedItem(value);
    };

    return (
        <>
            {isSelecting ? (
                <>
                    <p>Select Finance Partner</p>
                    <br />
                    <Select onChange={onChange} placeholder="Select Finance Partner" defaultValue={selectedItem}>
                        {items.map((item) => (
                            <Select.Option key={item.key} value={item.value}>
                                {item.text}
                            </Select.Option>
                        ))}
                    </Select>
                    <br />
                    <br />
                    <div className="modal-bottom-action-button-container">
                        <Button
                            variant="btn-primary"
                            size="btn-md"
                            className="modal-cancel-button"
                            onClick={cancelFinalize}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="btn-primary"
                            size="btn-md"
                            className="modal-confirm-button"
                            onClick={onRetrieveEstimate}
                        >
                            Retrieve Estimate
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    {isLoading ? (
                        <p>
                            <Spin /> &nbsp;Retrieving {selectedItem} Estimate information from Finance Partner. Please wait...
                        </p>
                    ) : (
                        <>
                            <h4>{selectedItem.toUpperCase()} Production :</h4>
                            <br />
                            <h3>{estimate} kW</h3>
                            <br />
                            {isError && (
                                <details>
                                    <summary>Error Details</summary>
                                    <br />
                                    <p>{selectedItem} API Error</p>
                                    <br />
                                    <p>{errorMessage}</p>
                                </details>
                            )}
                            <br />
                            <div className="modal-bottom-action-button-container">
                                <Button
                                    variant="btn-primary"
                                    size="btn-md"
                                    className="modal-info-button"
                                    onClick={onGoBack}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    variant="btn-primary"
                                    size="btn-md"
                                    className="modal-cancel-button"
                                    onClick={cancelFinalize}
                                >
                                    Close
                                </Button>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default ProductionEstimateForm;
